




















import { Input } from 'element-ui'
import { Vue, Prop, Component, Ref } from 'vue-property-decorator'

import Currency from '@/models/currency'

import { currencySymbol } from '@/globalMixin'

@Component({
  components: {
    [Input.name]: Input,
  },
})
export default class CustomInputNumber extends Vue {
  @Prop() size!: string
  @Prop() currencyCode!: Currency
  @Prop({ default: '' }) amountText!: string // What appears in the field, as a normal money string (dollars/euros, e.g. "123.45"). Parent keeps this in sync when the user types or blurs.
  @Ref('inputRef') readonly inputRef!: HTMLInputElement

  symbol = currencySymbol(this.currencyCode)

  get sizeClass(): string {
    return this.size ? `el-input--${this.size}` : ''
  }

  handleCustomAmountInput(amount: string): void {
    const moneyRegex = /^(\d+[.,]?(\d{1,2})?)?$/
    if (!moneyRegex.test(amount)) {
      return
    }
    this.$emit('input', amount.replace(',', '.'))
  }

  handleCustomAmountChange(amount: string): void {
    const roundedAmount = parseFloat(
      (amount === '' ? '0.00' : amount).replace(',', '.'),
    ).toFixed(2)
    this.$emit('change', roundedAmount)
  }
}
